<template>
    <div style="height:100%; background-color:#ff6100;">
        <div style="display:flex; flex-direction: column;height:100%; position:relative;">

            <div style="flex:1; display:flex; justify-content: center; align-items: center; position:relative; z-index:-2"> </div>
            <div style="text-align:center; margin-bottom:50px;">
                <div style="font-size:0px;"><a href="javascript:void(0)" style="display:inline-block;" @click="login"><img :src="require('@/assets/kakao_login_btn.png')" style="width:200px; "></a></div>
                <div style="margin-top:10px;"><a href="javascript:void(0)" style="color:#3d3d3d; " @click="() => {$GlobalRouter.push('/view/home' + '?' + new Date().getTime())}">잠깐만 더 구경할래요!</a></div>
            </div>
            <div style="font-weight:bold; text-align:center; font-size:13px; color:white; padding: 30px 0px;">OBYUNGYEAR</div>
            <div style="position:absolute; left:0px; top:50%; transform: translateY(calc(-50% - 40px)); width:100%;display:flex; justify-content: center; align-items:center;">
                <img :src="require('@/assets/intro.jpg')" style="width:250px;">
            </div>
        </div>
    </div>
</template>

<script>
    // import axios from 'axios';
    import {initialRouteStr} from "../../Constants";

    export default {
        name: "Intro",
        methods : {
            login(){
                this.$GlobalStore.addModal('KaKaoLogin', {test : 1});
            },
        },
        created(){
            this.$GlobalRouter.push(initialRouteStr);
        }
    }
</script>

<style scoped>

</style>